import img from "./TEF-logo.png";

export const AccountToggle = () => {
  return (
    <div className="">
      <div className="pb-5">
        <div className="logo">
          <a
            href="/"
            className="router-link-active router-link-exact-active"
            aria-current="page"
          >
            <img src={img} alt="" className="max-w-[160px] m-auto" />
          </a>
        </div>
      </div>
    </div>
  );
};
